import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>MockExamCreator - 2025</p>
        </footer>
    );
};

export default Footer;